export const CertificateErrors: Record<string, string> = {
  'The certificate is being used.': 'O certificado está sendo usado.',
};
